<template lang="pug">
.apo-banner
  .details
    b Shop Rogue Fitness APO to ship the gear you need to US Military addresses.
    div Not shipping to an APO / FPO / DPO military address?
    div
      rogue-link(class='subtle-link' to='https://www.roguefitness.com') Visit: www.roguefitness.com
</template>
<style lang="scss" scoped>
.apo-banner {
  padding: $space-xs $space-s;
  background: $color-gray-x-light;
  color: $color-black;
  text-align: center;
  font-size: $size-xs;

  .subtle-link {
    color: $color-black;
  }

  .details {
    div {
      margin: 5px 5px;
    }
  }

}

</style>
